import { NgModule } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  imports: [MarkdownModule.forChild()],
})
export class AdminAlertsModule {}
